import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';
import { AvatarModule } from 'src/app/ui/components/avatar/avatar.module';

import { AvatarSidebarCellModule } from '../../../components/avatar-sidebar-cell/avatar-sidebar-cell.module';
import { LogoModule } from '../../../components/logo/logo.module';
import { SidebarCellModule } from '../../../components/sidebar-cell/sidebar-cell.module';
import { SidebarComponent } from './sidebar.component';

@NgModule({
  declarations: [SidebarComponent],
  exports: [SidebarComponent],
  imports: [
    CommonModule,
    AvatarModule,
    LogoModule,
    NgxBootstrapIconsModule,
    SidebarCellModule,
    AvatarSidebarCellModule,
  ],
})
export class SidebarModule {}
